import http from '@/components/new/common/httpRequest/http'

const state = () => ({
  elementOffsetTop: {},
  previewModelId: null
})

const getters = {}

const actions = {
  // 官网预览体验模型
  getPreviewModel({ commit }) {
    return new Promise((resolve, reject) => {
      http('/api/website/recommendModel').then(res => {
        if(res.data.status !== 200) {
          return reject(res)
        }
        if(res.data.data && res.data.data.length) {          
          let { modelPkId: id } = res.data.data[0]
          commit('SET_MODEL', id)
          resolve(res)
        }
      })
    })
  }
}

const mutations = {
  SET_TOP(state, top) {
    state.elementOffsetTop = top
  },
  SET_MODEL(state, modelId) {
    console.log(modelId);
    state.previewModelId = modelId
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}